module.exports = __webpack_public_path__ + "fonts/ffdinwebpro-medium.eot";